import type { CSSProperties } from "react";

interface KuvioIconProps {
  size?: number;
  style?: CSSProperties;
}

export function KuvioIcon({ size = 24, style }: KuvioIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      <rect x="1" y="1" width="9" height="9" rx="2" className="kuvio-mark-purple" />
      <rect x="11.5" y="1" width="9" height="9" rx="2" className="kuvio-mark-ghost-purple" />
      <rect x="22" y="1" width="9" height="9" rx="2" className="kuvio-mark-coral" />
      <rect x="1" y="11.5" width="9" height="9" rx="2" className="kuvio-mark-blue" />
      <rect x="11.5" y="11.5" width="9" height="9" rx="2" className="kuvio-mark-amber" />
      <rect x="22" y="11.5" width="9" height="9" rx="2" className="kuvio-mark-ghost-amber" />
      <rect x="1" y="22" width="9" height="9" rx="2" className="kuvio-mark-coral-2" />
      <rect x="11.5" y="22" width="9" height="9" rx="2" className="kuvio-mark-ghost-teal" />
      <rect x="22" y="22" width="9" height="9" rx="2" className="kuvio-mark-teal" />
    </svg>
  );
}
